import { render, staticRenderFns } from "./ModalStaffEdit.vue?vue&type=template&id=385494dc&scoped=true&"
import script from "./ModalStaffEdit.vue?vue&type=script&lang=js&"
export * from "./ModalStaffEdit.vue?vue&type=script&lang=js&"
import style0 from "./ModalStaffEdit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ModalStaffEdit.vue?vue&type=style&index=1&id=385494dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385494dc",
  null
  
)

export default component.exports